/**
 * Given a string, removes any characters that we wouldn't want displayed in the Other Amount Input
 */
export const removeInvalidInputCharacters = s => {
  const cleanedNumberString = s
  // Remove non-numeric characters except for decimal points and commas
  .replace(/[^\d.,]/g, '')
  // Replace multiple consecutive commas with a single comma
  .replace(/,{2,}/g, ',')
  // Replace multiple consecutive decimal points with a single decimal point
  .replace(/\.{2,}/g, '.');
  return cleanedNumberString;
};